module.exports = __webpack_public_path__ + "img/hfcz-banner@2x.7dac4711.png";